import React from 'react';
import { Feed, Icon } from 'semantic-ui-react';
import moment from 'moment';

const feedItemStyles = {
  borderBottom: '1px dashed #eee',
};

const feedSummaryStyle = {
  color: 'rgba(0,0,0, 0.7)',
};

const iconStyle = {
  marginTop: 5,
};

const ACRCampaignScannedEvent = ({
  createdDate,
  assetCount,
}) => (
  <Feed.Event style={feedItemStyles}>
    <Feed.Label>
      <Icon style={iconStyle} name="search" color="green" />
    </Feed.Label>
    <Feed.Content>
      <Feed.Date>{createdDate && moment(createdDate).fromNow()}</Feed.Date>
      <Feed.Summary style={feedSummaryStyle}>
        <span>Channel scan. Found { assetCount } posts.</span>
      </Feed.Summary>
    </Feed.Content>
  </Feed.Event>
);

export default ACRCampaignScannedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/acr-campaign-scanned-event.js
 **/